SupportLocalStatusAndNotesPresentation =
	editable:
		status: "Can be edited until <span class='localtime'>{{editable_deadline}}</span>"
		notes: "You can edit this order until <span class='longlocaltime'>{{editable_deadline}}</span>. However, it cannot be edited after you have viewed or printed your Groupon voucher."
	not_editable:
		purchased:
			status: "Ready to print"
			notes: "To use your Groupon, click \"View Voucher\" and follow the steps under \"How to Use This\" on your Groupon."
		redeemed:
			status: "Used on <span class='localtime'>{{redeemed_date}}</span>"
			notes: ""
		available:
			status: "Ready to print"
			notes: "To use your Groupon, click \"View Voucher\" and follow the steps under \"How to Use This\" on your Groupon. "
		expired:
			status: "Expired"
			notes: ""
		expired_unredeemed:
			status: "Promotional value expired on <span class='utctime'>{{expiration_date}}</span>"
			notes: "Even though your Groupon has expired, you can still redeem it at <strong>{{merchant_name}}</strong> for the amount you paid for it."
		expired_redeemed:
			status: "Used on <span class='localtime'>{{redeemed_date}}</span>"
			notes: ""

module.exports = SupportLocalStatusAndNotesPresentation
